import { useQuery } from "react-query";
import adviceService from "../../services/adviceService";

export default function useAdviceDetails(id) {
    return useQuery(
        ['advice-details', id],
        () => adviceService.fetchAdviceDetails(id),
        {
            enabled: !!id
        }
    );
} 